/**
 * TanStack Query hooks for `no-code-rule-builder-with-natural-language-prompts`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	noCodeRuleBuilderWithNaturalLanguagePromptsQueryKeys,
	type CreateNoCodeRuleBuilderWithNaturalLanguagePromptsBody,
	type ListNoCodeRuleBuilderWithNaturalLanguagePromptsResponse,
	type NoCodeRuleBuilderWithNaturalLanguagePromptsRow,
} from "./api";

export function useNoCodeRuleBuilderWithNaturalLanguagePromptsList(): UseQueryResult<ListNoCodeRuleBuilderWithNaturalLanguagePromptsResponse, Error> {
	return useQuery({
		queryKey: noCodeRuleBuilderWithNaturalLanguagePromptsQueryKeys.list(),
		queryFn: list,
	});
}

export function useNoCodeRuleBuilderWithNaturalLanguagePromptsCreate(): UseMutationResult<NoCodeRuleBuilderWithNaturalLanguagePromptsRow, Error, CreateNoCodeRuleBuilderWithNaturalLanguagePromptsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: noCodeRuleBuilderWithNaturalLanguagePromptsQueryKeys.all });
		},
	});
}

export function useNoCodeRuleBuilderWithNaturalLanguagePromptsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: noCodeRuleBuilderWithNaturalLanguagePromptsQueryKeys.all });
		},
	});
}
